/**
 * Cliente do GDD: o documento inteiro numa leitura, e a escrita por seção.
 *
 * <p>A leitura traz as quarenta e seis seções de uma vez — o documento é para ser lido
 * corrido e o índice pula entre elas, então paginar só acrescentaria espera no meio da
 * revisão. A escrita é por seção, com a versão que a tela leu: é o que impede duas
 * pessoas revisando partes diferentes de apagarem o trabalho uma da outra.
 */
import { api } from '../../api/cliente';

const BASE = '/api/projetos/mistik-island/gdd';

export interface SecaoDoGdd {
  id: number;
  chave: string;
  numero: string;
  titulo: string;
  grupo: string;
  /** HTML do documento original — a tela higieniza antes de desenhar. */
  conteudo: string;
  revisada: boolean;
  ordem: number;
  /** A versão desta leitura; volta na gravação como trava. */
  versao: number;
  atualizadoPor?: string;
  atualizadoEm?: string;
}

export interface DocumentoDoGdd {
  secoes: SecaoDoGdd[];
  total: number;
  revisadas: number;
}

export const chaveDoGdd = ['gdd', 'mistik-island'] as const;

export function ler(): Promise<DocumentoDoGdd> {
  return api<DocumentoDoGdd>(BASE);
}

export function salvarSecao(
  id: number,
  conteudo: string,
  versaoBase: number,
  titulo?: string
): Promise<SecaoDoGdd> {
  return api<SecaoDoGdd>(`${BASE}/secoes/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ conteudo, titulo, versaoBase }),
  });
}

export function marcarRevisada(id: number, revisada: boolean): Promise<SecaoDoGdd> {
  return api<SecaoDoGdd>(`${BASE}/secoes/${id}/revisao`, {
    method: 'PATCH',
    body: JSON.stringify({ revisada }),
  });
}
